import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../environments/environment";
import * as fileSaver from "file-saver";
import { Subject, of } from "rxjs";
import { map, catchError } from "rxjs/operators";

@Injectable()
export class ProfileService {
  closeMandatoryEditWindow = new Subject<boolean>();
  showAddProfileSub = new Subject<boolean>();

  constructor(private http: HttpClient) {}

  //Get profile list from library
  getProfileFromLibrary(agentId, entities = null) {
    return this.http
      .post(
        environment.va_service_api + agentId + '/profile_library/list_profiles' , entities
      )
  }

  //Get mapped profiles under topic
  getMappedTopicProfile(agentId, topicUri) {
    return this.http
      .get(
        environment.profile_service_api +
          agentId +
          "/" +
          topicUri +
          "/" +
          "mapped_profiles/topic"
      )
  }

  //To get feature profiles
  getFeatureProfiles(agentId, topicUri, featureUri) {
    return this.http
      .get(
        environment.profile_service_api +
          agentId +
          "/" +
          topicUri +
          "/" +
          featureUri +
          "/get_profile_list"
      )
  }

  //Get mapped profiles under feature
  getMappedFeatureProfile(agentId, topicUri, featureUri) {
    return this.http
      .get(
        environment.profile_service_api +
          agentId +
          "/" +
          topicUri +
          "/" +
          featureUri +
          "/mapped_profiles/feature"
      )
  }

  //Add profile to topic
  addTopicProfile(agent_id, param) {
    return this.http
      .post(
        environment.profile_service_api + agent_id + "/add_profile_topic",
        param
      )
  }

  deleteProfileInTopicMappedUnderFeature(
    agent_id,
    topic_uri,
    attached_topic_uri,
    feature_uri,
    profile_id
  ) {
    let url: any;
    if (attached_topic_uri != undefined && attached_topic_uri != "") {
      url =
        environment.profile_service_api +
        agent_id +
        "/" +
        topic_uri +
        "/" +
        attached_topic_uri +
        "/" +
        feature_uri +
        "/" +
        profile_id +
        "/profile_content";
    }
    // else{
    //   url = environment.multi_topic_api + agent_id +'/'+topic_uri+"/"+feature_uri+'/profile_content';
    // }
    return this.http.delete(url)
  }
  //Add profile to feature
  addFeatureProfile(agent_id, topicName, param) {
    let url;
    if (topicName != "" && topicName != undefined) {
      url =
        environment.profile_service_api +
        agent_id +
        "/profile_content?topic=" +
        topicName;
    } else {
      url = environment.profile_service_api + agent_id + "/profile_content";
    }
    return this.http.post(url, param)
  }

  getSuggestedFeatureProfiles(agentId, topicUri, featureUri) {
    return this.http
      .get(
        environment.profile_service_api +
          agentId +
          "/" +
          topicUri +
          "/" +
          featureUri +
          "/suggested_profiles/feature"
      )
  }
  getSuggetedTopicProfiles(agentId, topicUri, featureUri) {
    return this.http
      .get(
        environment.profile_service_api +
          agentId +
          "/" +
          topicUri +
          "/" +
          featureUri +
          "/suggested_profiles/topic"
      )
  }
  getProfileContentUnderFeature(
    agentId,
    topicUri,
    attached_topic_uri,
    featureUri
  ) {
    let url: any;
    if (attached_topic_uri != undefined && attached_topic_uri != "") {
      url =
        environment.profile_service_api +
        agentId +
        "/" +
        topicUri +
        "/" +
        attached_topic_uri +
        "/" +
        featureUri +
        "/profile_content";
    } else {
      url =
        environment.profile_service_api +
        agentId +
        "/" +
        topicUri +
        "/" +
        featureUri +
        "/profile_content";
    }
    return this.http.get(url)
  }

  getEntityList(agentId, profileId) {
    let url: any;

    url =
      environment.va_service_api +
      agentId +
      "/profile_library/" +
      profileId +
      "/get_profile_entities?mandatory=" +
      true;

    return this.http.get(url)
  }
  //create profile in profile library
  createProfile(agentId, param) {
    return this.http
      .post(
        environment.va_service_api + agentId + "/profile_library/create",
        param
      )
  }

  //view profile data fetch
  viewProfile(agentId, profile_id) {
    return this.http
      .get(
        environment.va_service_api +
          agentId +
          "/profile_library/" +
          profile_id +
          "/view_profile"
      )
  }

  exportProfile(agentId, profile_id, profileName) {
    return this.http.get(environment.va_service_api +agentId +"/profile_library/" + profile_id + "/export_profile").pipe(
        map((response: any) => {
          let blob = new Blob([JSON.stringify(response)], {type: "application/json"});
          fileSaver.saveAs(blob, `${profileName}_${agentId}.json`);
        }),
        catchError((err: any) => {
          console.log(err);
          return of(null); // Return observable to handle error
        })
      )
  }
  importProfile(agentId, file) {
    const formData: FormData = new FormData();
    formData.append("file", file, file.name);
    return this.http
      .post(
        environment.va_service_api +
          agentId +
          "/profile_library/import_profile",
        formData,
        {
          headers: new HttpHeaders().set("Content-Type", "multipart/form-data"),
        }
      )
  }
  //Update profile content in profile library
  updateProfile(agentId, profileId, param) {
    return this.http
      .put(
        environment.va_service_api +
          agentId +
          "/profile_library/" +
          profileId +
          "/update",
        param
      )
  }
  //Delete profile from topic
  deleteProfileFromTopic(agentId, topicUri, profileID) {
    return this.http
      .delete(
        environment.profile_service_api +
          agentId +
          "/" +
          topicUri +
          "/" +
          profileID +
          "/mapped_profiles/topic"
      )
  }
  //Delete profile from feature
  deleteProfileFromFeature(
    agentId,
    topicUri,
    attached_topic_uri,
    featureUri,
    profileID
  ) {
    let url: any;
    if (attached_topic_uri != undefined && attached_topic_uri != "") {
      url =
        environment.profile_service_api +
        agentId +
        "/" +
        topicUri +
        "/" +
        attached_topic_uri +
        "/" +
        featureUri +
        "/" +
        profileID +
        "/profile_content";
    } else {
      url =
        environment.profile_service_api +
        agentId +
        "/" +
        topicUri +
        "/" +
        featureUri +
        "/" +
        profileID +
        "/profile_content";
    }
    return this.http.delete(url)
  }

  //Delete profile from library
  deleteProfile(agentId, profileId, param) {
    return this.http
      .delete(
        environment.va_service_api +
          agentId +
          "/profile_library/" +
          profileId +
          "/delete",
        param
      )
  }

  getProfileMappedKnowledge(agentId, profileId, restricted) {
    return this.http
      .get(
        environment.va_service_api +
          agentId +
          "/profile_library/" +
          profileId +
          "/get_mapped_knowledge?restricted=" +
          restricted
      )
  }

  getAskbackData(agentId, entityName) {
    return this.http
      .get(
        environment.va_service_api +
          agentId +
          "/profile_library/get_entities_askback/" +
          entityName
      )
  }

  upsertAskbackData(agentId, params) {
    return this.http
      .post(
        environment.va_service_api +
          agentId +
          "/profile_library/upsert_entities_askback",
        params
      )
  }

  deleteAskbackData(agentId, askbackId, profileName) {
    return this.http
      .delete(
        environment.va_service_api +
          agentId +
          "/profile_library/delete_entities_askback/" +
          askbackId +
          "?profile=" +
          profileName
      )
  }

  addRestrictedProfile(agentId, param) {
    return this.http
      .post(
        environment.profile_service_api + agentId + "/add_restricted_profile",
        param
      )
  }
  removeRestrictedProfile(agentId, param) {
    return this.http
      .delete(
        environment.profile_service_api +
          agentId +
          "/" +
          param.topic_uri +
          "/" +
          param.attached_topic_uri +
          "/" +
          param.feature_uri +
          "/" +
          param.restricted_profile +
          "/remove_restricted_profile"
      )
  }

  getRestrictedProfiles(agentId, param) {
    return this.http
      .get(
        environment.profile_service_api +
          agentId +
          "/" +
          param.topic_uri +
          "/" +
          param.attached_topic_uri +
          "/" +
          param.feature_uri +
          "/get_restricted_profiles"
      )
  }
}
